"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _home = require("@/api/home");
var _dayjs = _interopRequireDefault(require("dayjs"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default2 = exports.default = {
  props: {
    timeType: {
      type: String,
      required: true,
      default: '日'
    },
    chartData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {
      config: {
        value: 0,
        lineDash: [10, 2]
      },
      isShow: true,
      cop: 0,
      projectInfo: {},
      dayColdPrice: [],
      dayColdPriceDate: [],
      monthColdPrice: [],
      monthColdPriceDate: [],
      yearColdPrice: [],
      jd: 0,
      echartfc: '',
      // 图表颜色
      zoom: '',
      zoomrAtio: ''
    };
  },
  watch: {
    chartData: function chartData(val) {
      var res = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(val)));
      if (this.timeType === '日') {
        this.cop = Number(res.dayColdPrice || res.dayCop || 0);
      }
      if (this.timeType === '月') {
        this.cop = Number(res.monthColdPrice || res.monthCop || 0);
      }
      if (this.timeType === '年') {
        this.cop = Number(res.yearColdPrice || res.yearCop || 0);
        if (this.yearColdPrice.length >= 1 && this.yearColdPrice[1] != 0 && this.yearColdPrice[1] != 0.0) {
          this.config = {
            value: (this.yearColdPrice[1] / this.cop * 100).toFixed(2),
            lineDash: [10, 2]
          };
        }
      }
      this.getCopData();
    }
  },
  mounted: function mounted() {
    this.getCopData();
  },
  created: function created() {
    if (JSON.parse(sessionStorage.getItem("projectInfo"))) {
      this.projectInfo = JSON.parse(sessionStorage.getItem("projectInfo"));
    }
  },
  methods: {
    getCopData: function getCopData() {
      var _this = this;
      return (0, _home.getCop)({
        projectId: this.projectInfo.id,
        type: 1
      }).then(function (res) {
        var history = Object.assign.apply(Object, [{}].concat((0, _toConsumableArray2.default)(res)));
        _this.dayColdPrice = (history.dayCop || []).map(function (e) {
          return e.copValue;
        });
        _this.dayColdPriceDate = (history.dayCop || []).map(function (e) {
          // return dayjs(e.dataTime).format("MM-DD");
          return e.dataTime.substr(5, 5);
        });
        _this.monthColdPrice = (history.monthCop || []).map(function (e) {
          return e.copValue;
        });
        _this.monthColdPriceDate = (history.monthCop || []).map(function (e) {
          return (0, _dayjs.default)(e.dataTime).format("MM");
        });
        _this.yearColdPrice = (history.yearCop || []).map(function (e) {
          return e.copValue;
        });
        _this.yearColdPrice.push(_this.projectInfo.copTargetValue);
        if (_this.yearColdPrice.length > 1) {
          _this.config.value = (_this.yearColdPrice[1] / _this.yearColdPrice[0] * 100).toFixed(2);
          _this.config = _objectSpread({}, _this.config);
        }
        if (_this.timeType === '日') {
          _this.getLineEcharts();
        }
        if (_this.timeType === '月') {
          _this.getBarEcharts();
        }
      });
    },
    getLineEcharts: function getLineEcharts() {
      var _this2 = this;
      var lineEcharts = this.$echarts.init(document.getElementById("eedata-chart-box"));
      lineEcharts.clear();
      var option = {
        grid: {
          left: "10%",
          right: "10%",
          top: "30%",
          bottom: "20%" // 也可设置left和right设置距离来控制图表的大小
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            inside: false,
            textStyle: {
              fontSize: '11'
            }
          },
          axisLine: {
            // y轴
            show: false,
            lineStyle: {
              color: '#ffffff' //x轴轴线颜色
            }
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          splitLine: {
            // 网格线
            show: false
          },
          data: this.dayColdPriceDate
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,1)",
          extraCssText: "box-shadow:0 0 18px rgba(0,120,234,0.1);color:#000000",
          textStyle: {
            fontSize: 12,
            lineHeight: 30
          },
          padding: 15
        },
        yAxis: {
          type: "value",
          show: false,
          axisLine: {
            // y轴
            show: false
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          splitLine: {
            // 网格线
            show: false
          }
        },
        //
        series: [{
          data: this.dayColdPrice,
          type: "line",
          areaStyle: {},
          lineStyle: {
            color: "#FACF55"
          },
          label: {
            show: true,
            position: 'top',
            color: this.echartfc
          },
          itemStyle: {
            label: {
              show: true
            },
            color: "rgb(250 207 85 / 40%)"
          }
        }]
      };
      lineEcharts.setOption(option);
      this.$nextTick(function () {
        _this2.zoom = document.body.style.zoom;
        _this2.zoomrAtio = (1 / document.body.style.zoom).toFixed(2);
      });
    },
    getBarEcharts: function getBarEcharts() {
      var barEcharts = this.$echarts.init(document.getElementById("eedata-chart-box-month"));
      barEcharts.clear();
      var option = {
        grid: {
          left: "10%",
          right: "10%",
          top: "20%",
          bottom: "20%" // 也可设置left和right设置距离来控制图表的大小
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          axisLabel: {
            inside: false,
            textStyle: {
              fontSize: '11'
            }
          },
          axisLine: {
            // y轴
            show: false,
            lineStyle: {
              color: '#ffffff',
              //x轴轴线颜色
              fontSize: '10'
            }
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          splitLine: {
            // 网格线
            show: false
          },
          data: this.monthColdPriceDate
        },
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,1)",
          extraCssText: "box-shadow:0 0 18px rgba(0,120,234,0.1);color:#000000",
          textStyle: {
            fontSize: 12,
            lineHeight: 30
          },
          padding: 15
        },
        yAxis: {
          type: "value",
          show: false,
          axisLine: {
            // y轴
            show: false
          },
          axisTick: {
            // y轴刻度线
            show: false
          },
          splitLine: {
            // 网格线
            show: false
          }
        },
        series: [{
          name: "",
          type: "bar",
          barWidth: "14",
          data: this.monthColdPrice,
          label: {
            show: true,
            position: 'top',
            color: this.echartfc
          },
          itemStyle: {
            label: {
              show: true,
              position: "top"
            },
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: "#1665D8"
            }, {
              offset: 0.68,
              color: "#257dff"
            }, {
              offset: 1,
              color: "#257dff"
            }])
          }
        }]
      };
      barEcharts.setOption(option);
    }
  }
};